<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.about') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="6">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.ourstory') }}
              </h2>
              <div class="font-weight-bold">
                {{ $t('title.dirname') }}
              </div>
              <h2 class="text-md-h5 font-weight-bold mb-5">
                I Nyoman Abdi, SE., M.eCom
              </h2>
              <p class="text-justify">
                {{ $t('content.aboutdir') }}
              </p>
              <v-img
                class="ml-auto"
                max-width="250"
                :src="require('../assets/dir-img.jpeg')">
              </v-img>
            </v-col>
            <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
              <!-- <v-divider vertical></v-divider> -->
            </v-col>
            <v-col cols="12" md="5">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.visi') }}
              </h2>
              <p>
                {{ $t('content.visi') }}
              </p>
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.misi') }}
              </h2>
              <ul v-if="$i18n.locale === 'en'">
                <li>
                  Organizing vocational education that can be accessed equitably by the community
                </li>
                <li>
                  Organizing vocational education with characters that meet the national and international standards
                </li>
                <li>
                  Carrying out robust research in the fields of applied science and technology
                </li>
                <li>
                  Carrying out community services based on the application of science and technology
                </li>
                <li>
                  Organizing cooperation in the APAC region
                </li>
                <li>
                  Developing an innovative, transparent and accountable governance system supported by international standard resources
                </li>
                <li>
                  Building tourism-oriented resources and institutions
                </li>
              </ul>
              <ul v-if="$i18n.locale === 'id'">
                <li>
                  Menyelenggarakan pendidikan vokasi yang dapat diakses secara merata dan merata bagi masyarakat
                </li>
                <li>
                  Menyelenggarakan pendidikan vokasi yang berkarakter bangsa dengan standar mutu nasional dan regional di Asia-Pasifik
                </li>
                <li>
                  Menyelenggarakan penelitian bertaraf internasional di bidang ilmu dan teknologi terapan
                </li>
                <li>
                  Menyelenggarakan pengabdian kepada masyarakat berbasis penerapan ilmu pengetahuan dan teknologi
                </li>
                <li>
                  Menyelenggarakan kerjasama di kawasan ASPAC
                </li>
                <li>
                  Mengembangkan sistem tata kelola yang inovatif, transparan, dan akuntabel yang didukung oleh sumber daya berstandar internasional
                </li>
                <li>
                  Membangun keunggulan institusi berorientasi pariwisata
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('header.pnb') }}
              </h2>
            </v-col>
            <v-col cols="12" md="9">
              <v-img
                :src="require('./../assets/about-01.jpg')"
                contain>
              </v-img>
            </v-col>
            <v-col cols="12" md="3" v-if="$i18n.locale === 'en'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.indata') }}
              </h2>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  1987
                </h2>
                <p>
                  PNB established
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  6.200
                </h2>
                <p>
                  Current Students
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  25k+
                </h2>
                <p>
                  alumni worldwide.
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  123.668 m2
                </h2>
                <p>
                  campus area.
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  Bali, Indonesia
                </h2>
                <p>
                  located at.
                </p>
              </div>
            </v-col>
            <v-col cols="12" md="3" v-if="$i18n.locale === 'id'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.indata') }}
              </h2>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  1987
                </h2>
                <p>
                  Politeknik Negeri Bali didirikan.
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  6.200
                </h2>
                <p>
                  mahasiswa saat ini
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  25k+
                </h2>
                <p>
                  alumni.
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  123.668 m2
                </h2>
                <p>
                  luas kampus.
                </p>
              </div>
              <div class="mb-5">
                <h2 class="text-md-h4 font-weight-bold">
                  Bali, Indonesia
                </h2>
                <p>
                  lokasi.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.department') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="false">
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/civil-engineering.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Civil Engineering
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 2 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>The Department of Civil Engineering aims to create professionals with international competitiveness in the field of civil engineering.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://sipil.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/mechanical-engineering.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Mechanical Engineering
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>The Mechanical Engineering Department offers learning with experts in the fields of machinery and sustainable energy and prioritizes hands-on experience in laboratories, workshops and industry.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://mesin.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/electrical.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Electrical Engineering
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 4 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>JTE is currently holding the Applied Undergraduate Study Program in Automation Engineering, the D3 in Electrical Engineering Study Program, and the D3 in Information Management Study Program, which are in line with the demands of the digital era and the current and future 4.0 industrial revolution.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://elektro.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/accounting.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Accounting
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>The Department of Accounting remains popular among school leavers. They hope, after completing their studies, they would become professionals in accounting and can compete globally.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://akuntansi.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/adinistrasi.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Business Administration
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>The Department of Commerce aims to become a leading vocational higher education institution that creates internationally competitive business graduates by 2025.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://bisnis.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex"
          cols="12"
          md="4">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="require('../assets/pariwisata.jpg')">
              <v-card-title class="card-title-block font-weight-bold">
                Tourism
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 4 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div>The Politeknik Negeri Bali Tourism Department (PNB) is one of the most competitive majors in the field of commerce at the Politeknik Negeri Bali.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                href="https://pariwisata.pnb.ac.id/"
                target="_blank">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="jurlist">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(jur, i) in jurlist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="jur.urlpic">
              <v-card-title class="card-title-block font-weight-bold">
                {{ jur.nama_jur }}
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              Have {{ jur.prodi }} Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div class="text-ellipsis--3">
                {{ jur.desc_jur }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                large
                text
                :to="{ name: 'Jurusan', params: { slug: jur.slug_jur }}">
                <v-icon :color="maincolor" large>
                  mdi-arrow-right-circle
                </v-icon>
                <span class="text-capitalize ml-1 text-mcolor font-weight-bold">{{ $t('button.readmore') }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'About',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    jurlist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-aboutus.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJurusan();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJurusan() {
      this.jurlist = [];
      this.axios
        .get(
          this.api + '/public/jurusan',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                element.urlpic = this.api + '/upload/jurusan/' + element.img_jur;
                this.jurlist.push(element);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
